<div>
  <div class="image-uploader">
    <input style="display: none"
      type="file"
      title="{{'Upload' | translate}}"
      id="docInput+{{formElementId}}"
      (change)="handleInputChangeDoc($event)">
      <label for="docInput+{{formElementId}}" class="file-input-label"
        [style.display]="'flex'">
        <span>{{'main.upload' | translate}}</span> <mat-icon>file_download</mat-icon>
      </label>

      @if (files && files.length) {
        <div class="message-box">
          {{'main.newFile' | translate}}
        </div>
      }
      @if (startProgress) {
        <div class="progress-bar">
          <div class="progress" [style.color]="progressDone ? 'green' : progressFail ? 'red' : 'black'">{{progressBar}}%</div>
          <mat-progress-bar mode="determinate" [value]="progressBar"></mat-progress-bar>
          @if (progressFail) {
            <div class="progress-error">{{'upload_file_error' | translate}}</div>
          }
        </div>
      }

      @for (file of files; track file; let i = $index) {
        <div >
          <div class="file-data">
            @switch (file.fileType) {
              @case ('doc') {
                <img src="assets/images/icons/doc.svg" style="width: 35px">
              }
              @case ('docx') {
                <img src="assets/images/icons/docx.svg" style="width: 35px">
              }
              @case ('jpg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('jpeg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('png') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('gif') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('svg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('pdf') {
                <img src="assets/images/icons/pdf.svg" style="width: 35px">
              }
              @case ('txt') {
                <img src="assets/images/icons/txt.svg" style="width: 35px">
              }
              @case ('xls') {
                <img src="assets/images/icons/xls.svg" style="width: 35px">
              }
              @default {
                <img src="assets/images/icons/file.svg" style="width: 35px">
              }
            }
            <span class="file-name">{{file.fileName}}</span>
            <mat-icon class="remove-icon" (click)="removeFile(file)">delete_outline</mat-icon>
          </div>
          @if (file.fileType === 'mp4' || file.fileType === 'avi' || file.fileType === 'mkv' || file.fileType === 'mov') {
            <div class="video-preview">
              <video  height="300" [src]="getVideo(file.url)" controls></video>
            </div>
          }
        </div>
      }


      @if (uploadedFiles && uploadedFiles.length) {
        <div class="message-box">
          {{'main.uplodedFile' | translate}}
        </div>
      }

      @for (file of uploadedFiles; track file) {
        <div>
          <div class="file-data">
            @switch (file.name.split('.')[1]) {
              @case ('doc') {
                <img src="assets/images/icons/doc.svg" style="width: 35px">
              }
              @case ('docx') {
                <img src="assets/images/icons/docx.svg" style="width: 35px">
              }
              @case ('jpg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('jpeg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('png') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('gif') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('svg') {
                <img src="assets/images/icons/img.svg" style="width: 35px">
              }
              @case ('pdf') {
                <img src="assets/images/icons/pdf.svg" style="width: 35px">
              }
              @case ('txt') {
                <img src="assets/images/icons/txt.svg" style="width: 35px">
              }
              @case ('xls') {
                <img src="assets/images/icons/xls.svg" style="width: 35px">
              }
              @default {
                <img src="assets/images/icons/file.svg" style="width: 35px">
              }
            }
            <span class="file-name">{{file.name}}</span>
            <mat-icon class="remove-icon" (click)="removeFileFromUpload(file)">delete_outline</mat-icon>
            <a [href]="getVideo(file.url)" target="_blank" rel="noopener noreferrer" ><mat-icon class="remove-icon">cloud_download</mat-icon></a>
          </div>
          @if (file.type === 'mp4' || file.type === 'avi' || file.type === 'mkv' || file.type === 'mov') {
            <div class="video-preview">
              <video height="300" [src]="getVideo(file.url)" controls></video>
            </div>
          }
        </div>
      }
    </div>
  </div>

